import { Box, Hidden, HStack, Skeleton, Stack, useMediaQuery, VStack } from 'native-base';
import { LoanOverviewSkeleton, StatusTrackerSkeleton } from '../index';
import React, { memo } from 'react';
const DocUploadSkeleton = () => {
  const [isSmallScreen] = useMediaQuery({
    maxWidth: 768
  });
  return /*#__PURE__*/React.createElement(VStack, {
    space: 4,
    p: "4"
  }, /*#__PURE__*/React.createElement(Stack, {
    flexDirection: {
      lg: 'row'
    },
    space: "4"
  }, /*#__PURE__*/React.createElement(Box, {
    flex: {
      lg: 2
    },
    mr: {
      lg: 10
    }
  }, /*#__PURE__*/React.createElement(StatusTrackerSkeleton, {
    dataTestID: "status-tracker-skeleton"
  })), /*#__PURE__*/React.createElement(Box, {
    flex: {
      lg: 1
    }
  }, /*#__PURE__*/React.createElement(LoanOverviewSkeleton, {
    dataTestID: "loan-overview-skeleton"
  }))), [0, 1, 2, 3, 4, 5].map(each => {
    return /*#__PURE__*/React.createElement(Box, {
      borderColor: "gray.200",
      borderLeftWidth: 8,
      borderWidth: 1,
      borderRadius: "md",
      h: "24",
      p: "4",
      key: each
    }, /*#__PURE__*/React.createElement(HStack, {
      alignItems: "center",
      justifyContent: "space-between",
      flex: 1
    }, /*#__PURE__*/React.createElement(HStack, {
      space: "4",
      alignItems: "center",
      flex: 1
    }, /*#__PURE__*/React.createElement(Skeleton, {
      w: "16",
      h: "16",
      rounded: "full"
    }), /*#__PURE__*/React.createElement(Skeleton.Text, {
      lines: isSmallScreen ? 1 : 2,
      maxW: "65%"
    })), /*#__PURE__*/React.createElement(Hidden, {
      till: "md"
    }, /*#__PURE__*/React.createElement(Skeleton, {
      h: "12",
      w: "40",
      justifyContent: "flex-end",
      borderRadius: "lg"
    })), /*#__PURE__*/React.createElement(Hidden, {
      from: "md"
    }, /*#__PURE__*/React.createElement(Skeleton, {
      h: "4",
      w: "4",
      rounded: "full"
    }))));
  }));
};
export default /*#__PURE__*/memo(DocUploadSkeleton);
//# sourceMappingURL=index.js.map